export default function(loan_list, slider){
  if (loan_list) {
    const loans = loan_list.querySelectorAll('.loans-list-item')
    // console.log('loans', loans);
    // console.log('slider.calculator', slider.calculator);
    let count = loans.length
    let count_visible = 0
    loans.forEach(loan => {
      if (
        slider.calculator.amount >= parseInt(loan.dataset.minAmount)
        && slider.calculator.amount <= parseInt(loan.dataset.maxAmount)
        && slider.calculator.repayment >= parseInt(loan.dataset.minLoanperiod)
        && slider.calculator.repayment <= parseInt(loan.dataset.maxLoanperiod)
      ) {
        loan.classList.remove('hidden')
        count_visible++;
        if (count_visible > 8) {
          loan.classList.add('should-hide')
        } else {
          loan.classList.remove('should-hide')
        }
      } else {
        loan.classList.add('hidden')
        count--;
      }
    })
    slider.link.innerText = `Jämför ${count} långivare`


    const loadMoreButton = loan_list.querySelector('.plugin-loan-list--more');
    if(loadMoreButton) {
      if (count_visible > 8) {
        loadMoreButton.classList.remove('hidden')
      } else {
        loadMoreButton.classList.add('hidden')
      }
    }

  }
}



// WEBPACK FOOTER //
// ./scripts/libs/filterLoans.js